<div class="container-fluid">
    <!-- Page Header with Action Buttons -->
    <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
        <h1 class="page-header mb-2 mb-lg-0">Royalty Report</h1>

        <!-- Action Buttons -->
        <div class="d-flex flex-column flex-md-row align-items-start align-items-md-center" style="margin-top: 0.5rem;">
            <div class="d-flex flex-wrap gap-1">
                <button
                    [disabled]="this.isDisabled"
                    [matTooltip]="disabledButtonTooltip"
                    [matTooltipDisabled]="!this.isDisabled"
                    style="color:#fff; background-color: #1C3F8B !important; border-color: #1C3F8B !important;"
                    mat-flat-button
                    class="me-1 mb-1"
                    (click)="openDialog(SendUpdateAPIComponent, null, {
                        endpoint: 'royalty_report_send_api',
                        operation: 'Send API',
                        form: { week: week, year: year }
                    });">Send Report</button>

                <button
                    [disabled]="this.isDisabled"
                    [matTooltip]="disabledButtonTooltip"
                    [matTooltipDisabled]="!this.isDisabled"
                    style="color:#fff; background-color: #1C3F8B !important; border-color: #1C3F8B !important;"
                    mat-flat-button
                    class="me-1 mb-1"
                    (click)="openDialog(SendUpdateAPIComponent, null, {
                        endpoint: 'royalty_report_send_api',
                        operation: 'Update API',
                        form: { week: week, year: year }
                    });">Update Report</button>

                <button style="background-color: transparent !important; border: none;"
                    (click)="onPrint()"
                    type="button"
                    mat-icon-button
                    class="me-1 mb-1"
                    matTooltip="Print royalty report"
                    matTooltipPosition="below"
                    aria-label="Print royalty report">
                    <mat-icon style="color: #1C3F8B;">print</mat-icon>
                </button>

                <button
                    style="color:#fff; background-color: #6c757d !important; border-color: #6c757d !important;"
                    mat-flat-button
                    class="me-1 mb-1"
                    [routerLink]="['/ami-reports']">
                    Back to list
                </button>
            </div>
        </div>
    </div>

    <app-report-nav-menu [week]="this.week" [year]="this.year" [currentReport]="this.currentReport"></app-report-nav-menu>

    <mat-expansion-panel>
        <mat-expansion-panel-header>
            <mat-panel-title>
                Filter
            </mat-panel-title>
            <mat-panel-description>
                <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
            </mat-panel-description>
        </mat-expansion-panel-header>
        <form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">
            <div class="row">

                <!-- Student Autocomplete -->
                <div class="col-2 d-none">
                    <mat-form-field class="full-width-field">
                        <mat-label>Student</mat-label>
                        <input #studentInput name="field_student_target_id" (input)="onAutocompleteStudent($event)" matInput ngModel
                            [matAutocomplete]="autoCompleteStudent">
                        <button (click)="redirectUserProfile(studentInput)" type="button" matSuffix mat-icon-button aria-label="manage_accounts">
                            <mat-icon>manage_accounts</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-autocomplete #autoCompleteStudent="matAutocomplete" (optionSelected)="onSubmit(f)">
                        <mat-option *ngFor="let option of autoCompleteStudentOptions"
                            [value]="option.label + ' ' + '(' + option.value + ')'">
                            {{option.label}} ({{option.value}})
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <!-- Packages Autocomplete -->
                <div class="col-2 d-none">
                    <mat-form-field class="full-width-field">
                        <mat-label>Sale Package</mat-label>
                        <input name="field_enrollment_package_name_target_id" (input)="onAutocompletePackages($event)"
                            matInput ngModel [matAutocomplete]="autoCompletePackages">
                        <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
                            <mat-icon>manage_accounts</mat-icon>
                        </button>
                    </mat-form-field>
                    <mat-autocomplete #autoCompletePackages="matAutocomplete" (optionSelected)="onSubmit(f)">
                        <mat-option *ngFor="let option of autoCompletePackageOptions"
                            [value]="option.label + ' ' + '(' + option.value + ')'">
                            {{option.label}} ({{option.value}})
                        </mat-option>
                    </mat-autocomplete>
                </div>

                <div class="col-2 d-none">
                    <mat-form-field class="full-width-field">
                        <mat-label>Date Paid</mat-label>
                        <input matInput [matDatepicker]="picker" name="field_date_and_time_value" ngModel
                            (dateChange)="onSubmit(f)">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>

                <app-week-year-selector
                    [initialWeek]="week"
                    [initialYear]="year"
                    [disableOnFutureWeek]="true"
                    [showNoneOption]="false"
                    (selectionChange)="onWeekYearChange($event)"
                    (isDisabledChange)="isDisabled = $event">
                </app-week-year-selector>

                <section class="section">

                    <div class="float-end bring-inline">
                        <button (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear
                            <!-- <mat-icon (click)="resetForm()" aria-hidden="false" aria-label="Menu dropdown" class=""></mat-icon> -->
                        </button>
                    </div>

                </section>
            </div>


            <section class="section">
            </section>

        </form>

    </mat-expansion-panel>

    <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

    <table class="mat-table cdk-table mat-sort mt-4" role="table"
        *ngIf="data != undefined && data['#royalty_header_table'] != undefined">
        <thead role="rowgroup">
            <tr>
                <th class="mat-header-cell">Report Type</th>
                <th class="mat-header-cell">Studio</th>
                <th class="mat-header-cell">Prepared By</th>
                <th class="mat-header-cell">Year</th>
                <th class="mat-header-cell">Week Number</th>
                <th class="mat-header-cell">Date Range</th>
            </tr>
        </thead>
        <tr>
            <td class="mat-row">{{ data['#royalty_header_table']['royalty_data_header']['#rows'][0][0] }}</td>
            <td class="mat-row">{{ currentStudio }}</td>
            <td class="mat-row">{{ data['#royalty_header_table']['royalty_data_header']['#rows'][0][1] }}</td>
            <td class="mat-row">{{ data['#royalty_header_table']['royalty_data_header']['#rows'][0][2] }}</td>
            <td class="mat-row">{{ data['#royalty_header_table']['royalty_data_header']['#rows'][0][3] }}</td>
            <td class="mat-row">{{ reportDateService.formatDate(data['#royalty_header_table']['royalty_data_header']['#rows'][0][5]) }} - {{ reportDateService.formatDate(data['#royalty_header_table']['royalty_data_header']['#rows'][0][6]) }}</td>
        </tr>
    </table>


    <div class="table-container">
        <mat-card *ngIf="this.royaltyDataRefunds?.[0]">
            <mat-card-title>
                Refunds
            </mat-card-title>

            <mat-card-content>
                <ng-container *ngFor="let dateKey of getSortedDateKeys()">
                    <ng-container *ngIf="getRefundsForDate(dateKey).length > 0">
                        <table class="mat-table cdk-table mat-sort" role="table" style="margin-bottom: 15px;">
                            <thead role="rowgroup">
                                <tr>
                                    <th class="mat-header-cell">Receipt Number</th>
                                    <th class="mat-header-cell">Student Name</th>
                                    <th class="mat-header-cell text-end">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let refund of getRefundsForDate(dateKey)">
                                    <td class="mat-row">{{ refund.receipt_number }}</td>
                                    <td class="mat-row">{{ refund.student_name }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(refund.total_receipts) | studioCurrency }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-container>
                </ng-container>
            </mat-card-content>
        </mat-card>

        <!-- All Receipts Table with Daily Subtotals -->
        <mat-card>
            <mat-card-title>
                All Receipts
            </mat-card-title>

            <mat-card-content>
                <table class="mat-table cdk-table mat-sort mt-4" role="table">
                    <thead role="rowgroup">
                        <tr>
                            <th class="mat-header-cell">Receipt Number</th>
                            <th class="mat-header-cell">Date Paid</th>
                            <th class="mat-header-cell">Student Name</th>
                            <th class="mat-header-cell">Executive Member</th>
                            <th class="mat-header-cell">Staff Member</th>
                            <th class="mat-header-cell">Sale Code</th>
                            <th class="mat-header-cell">Sale Package</th>
                            <th class="mat-header-cell">Lesson Count</th>
                            <th class="mat-header-cell text-end">Total Price</th>
                            <th class="mat-header-cell text-end">Cash</th>
                            <th class="mat-header-cell text-end" *ngIf="displayedColumns.includes('field_tax_amount')">Tax</th>
                            <th class="mat-header-cell text-end">Misc/Non Unit</th>
                            <th class="mat-header-cell text-end">Subject to Royalty</th>
                            <th class="mat-header-cell text-end">Sundry</th>
                            <th class="mat-header-cell text-end">Total Receipts</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="isDataReady">
                        <ng-container *ngFor="let dateKey of getSortedDateKeys(); trackBy: trackByDate">
                            <ng-container *ngIf="getSafeGroupedDataByDay()[dateKey]?.length > 0">
                                <!-- Date Header Row -->
                                <tr class="date-header-row" style="background-color: #e3f2fd; font-weight: bold; border-top: 2px solid #2196f3;">
                                    <td class="mat-row" [attr.colspan]="displayedColumns.includes('field_tax_amount') ? 15 : 14" style="text-align: center; padding: 12px;">
                                        {{ reportDateService.formatDate(dateKey) }}
                                    </td>
                                </tr>
                                <!-- Daily Receipts -->
                                <tr *ngFor="let row of getSafeGroupedDataByDay()[dateKey]; trackBy: trackByRowId"
                                    [ngClass]="{'refund-row': +row.total_receipts < 0}"
                                    >
                                    <td class="mat-row">{{ row.receipt_number }}</td>
                                    <td class="mat-row">{{ reportDateService.formatDate(row.date_paid) }}</td>
                                    <td class="mat-row">{{ row.student_name }}</td>
                                    <td class="mat-row">{{ row.field_executive_display }}</td>
                                    <td class="mat-row">{{ row.field_instructor_display }}</td>
                                    <td class="mat-row">{{ row.sale_code }}</td>
                                    <td class="mat-row">{{ row.package_name }}</td>
                                    <td class="mat-row">{{ row.lesson_count }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(row.total_price) | studioCurrency }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(row.cash) | studioCurrency }}</td>
                                    <td class="mat-row text-end" *ngIf="displayedColumns.includes('field_tax_amount')">{{ formatMoney(row.field_tax_collected) | studioCurrency }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(row.miscellaneous_services) | studioCurrency }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(row.subject_to_royalty) | studioCurrency }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(row.sundry) | studioCurrency }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(row.total_receipts) | studioCurrency }}</td>
                                </tr>
                                <!-- Daily Subtotal Row -->
                                <tr class="subtotal-row" *ngIf="getSafeSubtotalForDate(dateKey) && getSafeSubtotalForDate(dateKey).cash !== undefined">
                                    <td class="mat-row" colspan="8">Daily Subtotal for {{ reportDateService.formatDate(dateKey) }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(getSafeSubtotalForDate(dateKey)?.total_price) | studioCurrency }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(getSafeSubtotalForDate(dateKey)?.cash) | studioCurrency }}</td>
                                    <td class="mat-row text-end" *ngIf="displayedColumns.includes('field_tax_amount')">{{ formatMoney(getSafeSubtotalForDate(dateKey)?.tax) | studioCurrency }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(getSafeSubtotalForDate(dateKey)?.miscellaneous_services) | studioCurrency }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(getSafeSubtotalForDate(dateKey)?.subject_to_royalty) | studioCurrency }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(getSafeSubtotalForDate(dateKey)?.sundry) | studioCurrency }}</td>
                                    <td class="mat-row text-end">{{ formatMoney(getSafeSubtotalForDate(dateKey)?.total_receipts) | studioCurrency }}</td>
                                </tr>
                            </ng-container>
                        </ng-container>
                    </tbody>
                </table>
            </mat-card-content>
        </mat-card>

        <!-- Totals Summary Table  -->
        <mat-card>
            <mat-card-title>
            Summary
            </mat-card-title>

            <mat-card-content>
                <table class="mat-table cdk-table mat-sort mt-4" role="table"
                    *ngIf="data != undefined && data['#royalty_header_table'] != undefined">
                    <thead role="rowgroup">
                        <tr>
                            <th class="mat-header-cell col-9"></th>
                            <th class="mat-header-cell col-1 text-end">Cash</th>
                            <th class="mat-header-cell col-1 text-end">Misc Services</th>
                            <th class="mat-header-cell col-1 text-end">Subject to Royalty</th>
                            <th class="mat-header-cell col-1 text-end">Sundry</th>
                            <th class="mat-header-cell col-1 text-end">Tax</th>
                            <th class="mat-header-cell col-1 text-end">Total Reciepts</th>
                        </tr>
                    </thead>
                    <!-- Total Subject To Percentage -->
                    <tr>
                        <td class="mat-row">Totals</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total?.['cash']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total?.['miscellaneous_services']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total?.['subject_to_royalty']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total?.['sundry']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total?.['tax']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total?.['total_receipts']) | studioCurrency }}</td>
                    </tr>
                    <!-- Deduct Refunds/Credits -->
                    <tr>
                        <td class="mat-row">Deduct Refunds/Credits</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_refunded?.['cash']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_refunded?.['miscellaneous_services']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_refunded?.['subject_to_royalty']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_refunded?.['sundry']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_refunded?.['tax']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_refunded?.['total_receipts']) | studioCurrency }}</td>
                    </tr>
                    <!-- Total Subject To Percentage -->
                    <tr>
                        <td class="mat-row">Total Subject To Percentage</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_include_refunded?.['cash']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_include_refunded?.['miscellaneous_services']) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_include_refunded?.['subject_to_royalty']) | studioCurrency }}</td>
                        <td class="mat-row"></td>
                        <td class="mat-row"></td>
                        <td class="mat-row"></td>
                    </tr>
                    <!-- Royalty Percentage -->
                    <tr>
                        <td class="mat-row">Weekly Net Due ({{(this.royaltyPercentage)}}%)</td>
                        <td class="mat-row text-end">{{ formatMoney(calcRoyaltyPercentage(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_include_refunded?.['cash'] || 0)) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(calcRoyaltyPercentage(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_include_refunded?.['miscellaneous_services'] || 0)) | studioCurrency }}</td>
                        <td class="mat-row text-end">{{ formatMoney(calcRoyaltyPercentage(data?.['#royalty_content_table']?.['staff_data_4_system']?.['#footer']?.[0]?.data?.total_include_refunded?.['subject_to_royalty'] || 0)) | studioCurrency }}</td>
                        <td class="mat-row"></td>
                        <td class="mat-row"></td>
                        <td class="mat-row"></td>
                    </tr>
                </table>
            </mat-card-content>

            <ng-container *ngIf="this.pageSize == 0">
                <div>
                    Please select criteria to generate a report.
                </div>
            </ng-container>
        </mat-card>

        <p style="margin-bottom:100px; height:100px;">&nbsp;</p>

        <!-- <mat-paginator (page)="pageChanged($event)" [pageSizeOptions]="onPageSizeOptions()" [length]="10"
        [disabled]="ShowProgressBar"
        [pageSize]="paginationTotalPages" [pageIndex]="paginationIndex" aria-label="Select page of view"></mat-paginator> -->

    </div>
</div>
